import React, { createContext } from 'react';

import { WsAlert } from '../../core';

type WsDeliverPortalContextProps = {
  currentUser: any | undefined;
  socketClient: SocketIOClient.Socket;
  setAlert: React.Dispatch<React.SetStateAction<WsAlert | undefined>>;
  setJobPanelVisible: React.Dispatch<React.SetStateAction<number>>;
  showBackgroundJob: ({ text, text2, url, id, progress, updateOrCreate }: { text: string, text2: string, url: string, id: string, progress: number, jobId: number, updateOrCreate: boolean }) => void;
};

const WsDeliverPortalContext = createContext<WsDeliverPortalContextProps | undefined>(undefined);

export {
  WsDeliverPortalContext
};
